<template>
  <div class="content">
    <div class="line">
      <img src="../../assets/img/common/activity_dec_title.png" class="title-img">
      <div class="activity-dec">
        <p>2022年“中文在线杯”全国高职高专院校信息素养大赛在全国拉开帷幕。本届大赛由教育部高等学校图书情报工作指导委员会高职高专院校分委员会、高等教育文献保障系统（CALIS）管理中心主办，深圳职业技术学院承办，湖北中文在线数字出版有限公司协办。</p>
        <p>信息时代，急需信息素养。本专题旨在提高新时代高职高专院校学生的信息素养，书香中国平台将以优质正版内容助力大赛顺利进行，促进全国高职高专院校信息素养教育全面健康发展。</p>
      </div>
    </div>
    
     <div class="line">
      <img src="../../assets/img/common/list_title.png" class="title-img">
      <div class="book-box">
        <div class="list">
         <div class="item"  v-for="(item,index) in bookList" :key="index">
             <a :href="item.url" target="_blank" class="book-cover"><img :src="item.cover" /></a>
             <div class="info">
                <div class="name ellipsis-1"><a :href="item.url" target="_blank">{{item.name}}</a></div>
                <div class="author">{{item.author}}</div>
                <div class="dec ellipsis-4">{{item.intro}}</div>
                <a :href="item.url"  target="_blank" class="btn">立即阅读</a>
             </div>
        </div>
          
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import { bookList } from "../../assets/js/data";
import footera from "./footer.vue";
export default {
  name: "content",
   components: {
    footera
  },
  data() {
    return {
      returnUrl: "",
      contentBg: "",
     
    };
  },
  created() {
    //this.setAinfo();
  },
  computed: {
    bookList() {
      return bookList;
    }
  },
  methods: {
    //  setAinfo(){//设置活动说明
    //   if(window.location.host=='sxdc.w.chineseall.cn'){ //书香东城
    //     this.ainfo="2022年8月10日前将于“书香东城全民阅读”及“中文在线微书房”公众号公布获奖情况。"
    //   }else{
    //     this.ainfo="2022年8月10日前将于“中文在线微书房”公众号公布获奖情况。"
    //   }
    // },
    getUrl() {}
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.content {
  width: 100%;
  height: auto;
  min-height: 100vh;
  padding: 0 0 0.68rem;
  margin: -3.4rem auto 0;
  position: relative;
  .line{
    width: 60%;
    margin: 0.4rem auto 0; 
    text-align: center;
    .title-img{
      width: 32.5%;
      height: auto;

    }
    .activity-dec{
      width: 100%;
      min-width: 12rem;
      height: auto;  
      padding: 0.53rem 0.48rem;
      background-color: #F1FEFF;
      border: 0.1rem solid #95FBFF;
      border-radius: 0.2rem;
      margin-top: 0.3rem;
      >p{
        width: 100%;
        text-align: left;
        font-size: 0.2rem;
        line-height: 2em;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #333333;
        text-indent: 2em; 
      }
      >p+p{
        margin-top: 0.2rem;
      }
    }
    .activity-prize{
      width: 100%;
      height: 7.28rem;
      padding: 0.6rem 0.6rem 0.9rem; 
      margin-top: 0.2rem;
      background:  url("../../assets/img/activity/prize_bg.png") no-repeat center;
      background-size: 100% 100%;
      .pirize{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item{
          width: 33%;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          .prize-img{
            width: 2.52rem;
            height: auto;
            border-radius: 50%;
        }
        .num{
          font-size: 0.22rem;
          color: #333333;
          font-weight: 400;
          margin-top: 0.2rem;
        }
        .name{
          font-size: 0.18rem;
          color: #333333;
          font-weight: 400;
          margin-top: 0.16rem;
        }
      }
      }
      .btn{
        width: 2.5rem;
        height: 0.64rem;
        display: inline-block;
        margin: 0.7rem auto 0;
        >img{
          width: 100%;
          height: 100%;
        }
      }
      .mark{
        width: 100%;
        height: auto;
        text-align: left;
        margin-top: 0.6rem;
        font-size: 0.2rem;
        color: #666;
        line-height: 1.8em;
      }
    }
    .book-box{
      width: 100%;
      min-width: 12rem;
      height: 14.55rem;
      padding: 0.6rem 0.5rem 0.8rem; 
      margin-top: 0.3rem;
      background-color: #F1FEFF;
      border: 0.1rem solid #95FBFF;
      border-radius: 0.2rem; 
      .list{
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .item{
          width: calc(50% - 0.25rem);
          font-size: 0.14rem;
          color: #333;
          font-weight: 400;
          display: flex;
          align-items: center;
          margin-bottom: 0.4rem;
          .book-cover{
            width: 1.74rem;
            height: 2.32rem;
            >img{
              width: 100%;
              height: 100%;
              box-shadow: 0 0.03rem 0.05rem -0.01rem rgb(0 0 0 / 20%), 0 0.06rem 0.1rem 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);
            }
          }
          .info{
            width: calc( 100% - 1.74rem);
            padding-left: 0.2rem;
            text-align: left;
          }
          .name{
            font-size: 0.18rem;
            font-weight: bold;
          }
          .author{
            width: 100%;
            margin-top: 0.16rem; 
          }
          .dec{
            margin-top: 0.16rem;
          }
          .btn{
            width: auto;
            height: 0.4rem;
            line-height: 0.4rem;
            background-color: #122CAA;
            border-radius: 0.04rem;
            display: inline-block;
            padding: 0 0.3rem 0;
            font-size: 0.14rem;
            color: #fff;
            text-align: center;
            margin-top: 0.16rem;
          }
          
        }
      }
    }
  }
  .line+.line{
    margin-top: 0.6rem;
  } 
}
</style>
